import { Box, Typography } from '@mui/material';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver_profiles_commonCaregiverProfile_payRange as CaregiverPayRange } from '@/__generated__/seoSegmentationListingPage';

export interface CaregiverRateProps {
  hourlyRateFrom: CaregiverPayRange['hourlyRateFrom'];
}

export const CaregiverRate = ({ hourlyRateFrom }: CaregiverRateProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Box component="dl" display="flex" flexDirection="column" alignItems="flex-end" m={0}>
      <Typography variant={isSmallViewport ? 'info1' : 'body3'} component="dt">
        from
      </Typography>
      <Typography variant={isSmallViewport ? 'h5' : 'h2'} component="dd">
        ${hourlyRateFrom.amount}/hr
      </Typography>
    </Box>
  );
};
